import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import seatingsReducer from './components/Bus/reducer';
import stepperReducer, {
  alertReducer,
  messagesReducer,
  otherContentreducer,
  paygateMessagesReducer,
  ticketIdreducer,
} from './containers/App/reducer';
import enterStationsReducer, {
  finalStationReducer,
} from './containers/ConnectionForm/reducer';
import connection, {
  connectionDetailReducer,
} from './containers/Connections/reducer';
import { myFavouritePassengersReducer } from './containers/FavouritePassengers/reducer';
import { loginReducer, userReducer } from './containers/Login/reducer';
import ticketsReducer from './containers/Passengers/reducer';
import poolingReducer from './containers/Pooling/reducer';
import { connectionParams } from './containers/ReservationConnectionForm/reducer';

export default combineReducers({
  routing: routerReducer,
  connection,
  connectionDetail: connectionDetailReducer,
  enterStations: enterStationsReducer,
  stationTo: finalStationReducer,
  connectionParams,
  tickets: ticketsReducer,
  form: formReducer,
  stepper: stepperReducer,
  login: loginReducer,
  user: userReducer,
  ticketId: ticketIdreducer,
  pooling: poolingReducer,
  messages: messagesReducer,
  paygateMessages: paygateMessagesReducer,
  seatings: seatingsReducer,
  otherContent: otherContentreducer,
  alert: alertReducer,
  myFavouritePassengers: myFavouritePassengersReducer,
});



// WEBPACK FOOTER //
// ./src/reducer.js